export const types = Object.freeze({
  FETCH_ALL: '@chargeDataLogs/fetchAll',
  SET_LOGS: '@chargeDataLogs/setLogs',
  UPLOAD_FILE: '@chargeDataLogs/uploadFile',
  SET_UPLOAD_STATUS: '@chargeDataLogs/setUploadStatus',
  CLEAR_UPLOAD_STATUS: '@chargeDataLogs/clearUploadStatus',
  SET_FILTERS: '@chargeDataLogs/setFilters',
  CLEAR_FILTERS: '@chargeDataLogs/clearFilters'
})

export function fetchAll(params = {}) {
  return { type: types.FETCH_ALL, payload: { params } }
}
export function setLogs({ logs = {} } = {}) {
  return { type: types.SET_LOGS, payload: { logs } }
}

export function uploadFile(file: File) {
  return { type: types.UPLOAD_FILE, file }
}

export function setUploadStatus({ status = '', message = '', errors = [] }) {
  return {
    type: types.SET_UPLOAD_STATUS,
    payload: { status, message, errors }
  }
}

export function clearUploadStatus() {
  return {
    type: types.CLEAR_UPLOAD_STATUS
  }
}

export function setFilters(filters = {}) {
  return { type: types.SET_FILTERS, payload: { filters } }
}

export function clearFilters() {
  return { type: types.CLEAR_FILTERS }
}
